import React from "react"
import styled from "styled-components"

export const Section = styled.section`
  padding: 4rem 0;
  @media (min-width: 992px) {
    padding: 6.5rem 0;
  }
  ${({ $tone }) => $tone === "soft" && `background: var(--wash);`}
  ${({ $tone }) =>
    $tone === "dark" &&
    `background: var(--navy-deep); color: #fff; h2, h3, h4 { color: #fff; } :focus-visible { outline-color: var(--sky); }`}
  ${({
    $compact,
  }) =>
    $compact &&
    `padding: 2.5rem 0; @media (min-width: 992px) { padding: 3rem 0; }`}
  ${({
    $lined,
  }) =>
    $lined &&
    `border-top: 1px solid var(--line); border-bottom: 1px solid var(--line);`}
`

const Head = styled.div`
  max-width: var(--measure);
  margin-bottom: 3rem;
  ${({ $center }) =>
    $center && `margin-left: auto; margin-right: auto; text-align: center;`}
  h2 {
    margin-bottom: 0.6rem;
  }
  p {
    margin: 0;
    font-size: 1.1875rem;
    line-height: 1.5;
    color: var(--muted);
  }
`

export const SectionHead = ({ id, title, lead, center }) => (
  <Head $center={center}>
    <h2 id={id}>{title}</h2>
    {lead ? <p>{lead}</p> : null}
  </Head>
)
